import React, { useState } from 'react';
import CustomButton from '../customButton';
import Modal from 'react-bootstrap/Modal';

export function CustomModal({ buttonTitle, buttonClassName, title, body, updateFilters }) {
  const [show, setShow] = useState(false);
  const [filterOptions, setFilterOptions] = useState({
    test: false,
    test_2: false,
    // supplier: false,
    // supplier_2:false,
  });

  const handleClose = () => {
    setShow(false);
    updateFilters(filterOptions);
  };

  const handleShow = () => setShow(true);

  const handleCheckboxChange = (category) => {
    const allDeselected = Object.keys(filterOptions).every((filterKey) => !filterOptions[filterKey]);
    if(allDeselected) {
      updateFilters(filterOptions);
    }

    setFilterOptions((prevOptions) => ({
      ...prevOptions,
      [category]: !prevOptions[category],
    }));
  }


  return (
    <div>
      <CustomButton 
      onClick={handleShow}
        label={buttonTitle}
        className={buttonClassName}

      />

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <label>
              <input
                type="checkbox"
                checked={filterOptions.test}
                onChange={() => handleCheckboxChange('test')}
              /> test
            </label>
            <br></br>
            <label>
              <input
                type="checkbox"
                checked={filterOptions.test_2}
                onChange={() => handleCheckboxChange('test_2')}
              /> test_2
            </label>
            {/* <label>
              <input
                type="checkbox"
                checked={filterOptions.supplier}
                onChange={() => handleCheckboxChange('supplier')}
              /> supplier
            </label>
            <br></br>
            <label>
              <input
                type="checkbox"
                checked={filterOptions.supplier_2}
                onChange={() => handleCheckboxChange('supplier_2')}
              /> supplier_2
            </label> */}
        </Modal.Body>
      </Modal>
  </div>
  );
}

export default CustomModal;